import httpRequest from "@/auth/http-client";

class CampaignItemService {
  private baseUrl = "api/v1/campaignitem";

  async delete(itemId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${itemId}`);
  }
}

const campaignItemService = new CampaignItemService();
export default campaignItemService;
